import { render, staticRenderFns } from "./EditLanguageContainer.vue?vue&type=template&id=ccef418e&"
import script from "./EditLanguageContainer.vue?vue&type=script&lang=js&"
export * from "./EditLanguageContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports